import { formatMoney } from '@aeris/money';
import { footerBlocks, headerBlocks, } from "./receipt-template.js";
import { printedDay } from "./statement.js";
const plain = (amount) => formatMoney(amount, { symbol: false });
export const settlementReceiptFor = (input) => {
    const blocks = headerBlocks({
        company: input.company,
        template: input.template,
    });
    blocks.push({ kind: 'rule' }, { kind: 'text', text: 'RECIBO DE PAGAMENTO', align: 'center', bold: true });
    if (input.reversed) {
        blocks.push({
            kind: 'text',
            text: 'ESTORNADO',
            align: 'center',
            big: true,
            bold: true,
        });
    }
    const who = input.customer.document === null
        ? input.customer.name
        : `${input.customer.name} (${input.customer.document})`;
    blocks.push({ kind: 'rule' }, {
        kind: 'text',
        text: `Recebemos de ${who} a importância de ${formatMoney(input.paid)}, referente a ${input.entryDescription}.`,
    }, { kind: 'rule' }, { kind: 'pair', label: 'Valor', value: plain(input.amount) });
    // Só o que houve: "Juros 0,00" em todo recibo convida a perguntar que juros.
    if (input.interest.units !== 0n) {
        blocks.push({ kind: 'pair', label: 'Juros', value: plain(input.interest) });
    }
    if (input.fine.units !== 0n) {
        blocks.push({ kind: 'pair', label: 'Multa', value: plain(input.fine) });
    }
    if (input.discount.units !== 0n) {
        blocks.push({
            kind: 'pair',
            label: 'Desconto',
            value: `-${plain(input.discount)}`,
        });
    }
    blocks.push({ kind: 'pair', label: 'TOTAL PAGO', value: plain(input.paid), bold: true }, { kind: 'rule' }, { kind: 'pair', label: 'Data', value: printedDay(input.settledOn) });
    if (input.method !== null) {
        blocks.push({ kind: 'pair', label: 'Forma', value: input.method });
    }
    if (input.receivedBy !== null) {
        blocks.push({
            kind: 'pair',
            label: 'Recebido por',
            value: input.receivedBy,
        });
    }
    blocks.push({
        kind: 'pair',
        label: input.remaining.units === 0n ? 'Título' : 'Ainda falta',
        value: input.remaining.units === 0n ? 'quitado' : plain(input.remaining),
    }, {
        kind: 'pair',
        label: 'Baixa',
        value: input.settlementId.slice(-8).toUpperCase(),
    }, { kind: 'feed', lines: 3 }, { kind: 'text', text: '______________________________', align: 'center' }, { kind: 'text', text: input.company.name, align: 'center' }, ...footerBlocks(input.template, 'settlement'), { kind: 'feed', lines: 2 }, { kind: 'cut' });
    return { kind: 'receipt', title: 'Recibo de pagamento', blocks };
};
//# sourceMappingURL=settlement-receipt.js.map